import React, { memo } from "react";
import { Link } from "react-router-dom";
const bluearrow =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/SingleBlogImg/bluearrows.svg";
const LinksShowingBlogTitle = ({ title }) => {
  return (
    <div className="flex justify-center mt-[14rem] mb-8 md:px-6 lg:px-3 px-4">
    <div className="flex items-center space-x-4 max-w-5xl w-full border-b border-gray-500">
      <Link to="/" className="flex items-center">
        <p className="cursor-pointer font-medium lg:text-xl md:text-xl text-base">
          Home
        </p>
      </Link>
      <img
        src={bluearrow}
        alt="Arrow-left blog navigation"
        title="navigation left arrow"
        className="w-4 h-4 mt-1"
      />
      <Link to="/blogs" className="flex items-center">
        <p className="cursor-pointer font-medium lg:text-xl md:text-xl text-base">
          Our Blog
        </p>
      </Link>
      <img
        src={bluearrow}
        alt="Arrow-right blog navigation"
        title="navigation right arrow"
        className="w-4 h-4 mt-1"
      />
      <Link className="flex items-center">
        <p className="cursor-pointer text-[#1C8DCC] font-medium lg:text-xl md:text-xl text-base">
          {title?.length > 15 ? `${title.substring(0, 15)}...` : title}
        </p>
      </Link>
    </div>
  </div>
  
  );
};

export default memo(LinksShowingBlogTitle);
